<template>
  <base-button class="btn-primary px-5" text="承認" />
</template>
  
  <script>
  import BaseButton from '@/views/atoms/BaseButton';
  
  export default {
    name: 'ApprovalButton',
    components: {
      BaseButton,
    },
  }
  </script>
  